import { render, staticRenderFns } from "./SubcontractorsReports.vue?vue&type=template&id=6ba31ad1"
import script from "./SubcontractorsReports.vue?vue&type=script&lang=js"
export * from "./SubcontractorsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports